<template>
  <input :class="className" :name="name" :value="value" :placeholder="placeholder" :readonly="readonly" type="text" @keydown="(e) => validateNumber(e)" @input="inputEvent">
</template>

<script>
export default {
	name: 'input-number',
	props: {
    className: String,
    inputEvent: Function,
    name: String,
    placeholder: String,
    readonly: Boolean,
    value: {
      type: [ Number, String ],
      required: true
		}
  },
	methods: {
		validateNumber(evt) {
			if (evt.keyCode == 8 || evt.keyCode == 46 || (evt.keyCode >= 37 && evt.keyCode <= 40)) {
				return true ;
			}
			if (evt.keyCode == 32 || isNaN(evt.key)) {
				evt.preventDefault();
			}
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/common/input-number.vue